<template>
  <path d="M6 4L18 12L6 20V12V4Z" />
</template>
